import { t } from '@hefe/i18n';
import { Tabs } from 'antd';
import GymsComponent from '../components/gyms/gyms.component';

export default function GymsPage() {
  return (
    <Tabs defaultActiveKey="1">
      <Tabs.TabPane key="1" tab={t('gyms.plural')}>
        <GymsComponent />
      </Tabs.TabPane>
    </Tabs>
  );
}
